import { Component, OnInit, Input, Output,
         EventEmitter, ViewChild } from '@angular/core';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { slide } from '../../animations';

@Component({
  selector: 'company-form-modal',
  templateUrl: './company-form-modal.component.html',
  styleUrls: ['./company-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class CompanyFormModalComponent implements OnInit {
  @ViewChild('previewProfileImg') previewProfileImg;
  @ViewChild('previewCoverImg') previewCoverImg;

  @Input()  selectedCompany: any;
  @Input()  companyType: string;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  company = {
    name: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    about: "",
    contactPerson: "",
    email: "",
    phone: "",
    tags: [],
    companyType: 'member'
  }

  uploadedProfileImage: File;
  uploadedCoverImage: File;

  constructor(
    private dbService: DBService,
    private csService: CloudStorageService
  ) { }

  ngOnInit() {
    if (this.selectedCompany) {
      this.company = this.selectedCompany;
      console.log(this.selectedCompany.tags);
    }

    if (this.companyType == 'vendor') {
      this.company.companyType = 'vendor';
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {
    if (this.selectedCompany && this.selectedCompany.$key) {
      this.dbService.updateCompany(this.selectedCompany.$key,
                                  this.company,
                                  this.uploadedProfileImage,
                                  this.uploadedCoverImage);
    } else {
      this.dbService.addCompany(this.company,
                                this.uploadedProfileImage,
                                this.uploadedCoverImage);
    }
    this.onHideModal();
  }

  onProfileImageChange(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewProfileImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);
    this.uploadedProfileImage = file;

  }

  onCoverImageChange(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewCoverImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);
    this.uploadedCoverImage = file;

  }

}



// WEBPACK FOOTER //
// ./src/app/companies/company-form-modal/company-form-modal.component.ts